import PropTypes from "prop-types";
import React, {useState} from "react";

import {connect} from "react-redux";
import {User} from "../../../public/assets/images/responsive/icons/user";
import {Cube} from "../../../public/assets/images/responsive/icons/cube";
import {PlannerBanner} from "./plannerBanner";
import Link from "next/link";

// interval need to be bigger than css transition
const SWITCH_IMAGE_INTERVAL = 3000

const RotatingBackground = ({kitchenPicture}) => {
    const [indexPicture, setIndexPicture] = useState(0);
    const handleChangeIndex = () => {
        if (indexPicture === kitchenPicture?.length - 1) {
            setIndexPicture(0)
        } else {
            setIndexPicture(indexPicture + 1)
        }
    }
    setTimeout(handleChangeIndex, SWITCH_IMAGE_INTERVAL);
    return (
        <div className="rotatingBackground" style={{backgroundImage: `url(${kitchenPicture[indexPicture]})`}}/>
    )
}

export const HomePage = ({kitchenPictures, userId}) => {

    function redirectToProjectPage(userId) {
        if (userId) {
            return '/Customer/Account/KitchenProjects/Id/' + userId
        } else {
            return '/Customer/Account/Identification'
        }
    }

    return (
        <div className="planner">
            <div className="homePage">
                <div className="sliderContainer">
                    {!!kitchenPictures && <RotatingBackground kitchenPicture={kitchenPictures}/>}
                    <div className="filter">
                        <div className="text">
                            <h1>
                                Créer et acheter en ligne votre cuisine BOX
                            </h1>
                            <h4>
                                BOX = des cuisines à petit prix, à emporter immédiatement !
                            </h4>
                        </div>
                        <div className="sliderButtons">
                            <Link href={redirectToProjectPage(userId)} passHref={true}>
                                <div className="sliderButton" onClick={(event) => {
                                    appData.actionTrigger.dispatch({
                                        trigger: "MyProjectsPlannerHomePageHandleClick"
                                    });
                                }}>
                                    <User/>
                                    <a title="Mon compte/ Mes projets">
                                        <p>Mon compte /<br/>Mes projets enregistrés</p>
                                    </a>
                                </div>
                            </Link>
                            <Link href='#' passHref={true}>
                                <div className="sliderButton" onClick={(event) => {
                                    appData.actionTrigger.dispatch({
                                        trigger: "NewProjectPlannerHomePageHandleClick",
                                        resolveCallback: function () {
                                            window.location.href = '/configurateur-3d-cuisine/choix-modele'
                                        }
                                    });
                                }}>
                                    <Cube/>
                                    <a title="Démarrer mon projet">
                                        <p>Démarrer mon projet<br/>en 3D</p>
                                    </a>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                <PlannerBanner
                    label="Pour découvrir toutes les collections sur-mesure de la gamme Signature, rendez-vous sur "
                    imgUrl="https://media.but-cuisines.fr/4_SITE/Image_Cuisine_2024.png"
                    aLabel="but-cuisines.fr"
                    link="https://www.but-cuisines.fr/"
                    eventLabel="Découvrir"
                    eventAction="Bandeau redirection but cuisine_Page d’accueil"
                />
            </div>
        </div>
    )
};

const mapStateToProps = (state, ownProps) => {
    return {
        kitchenPictures: ownProps.kitchenPictures,
        userId: ownProps.templateVersion === 'Default' && state.header.customer.group === 'WebCustomers' ? state.header.customer.userId : ownProps.templateVersion === 'Mobile' && state.identity.userData.group === 'WebCustomers' ? state.identity.userData.userId : null
    }
}

export default connect(mapStateToProps, null)(HomePage);
